import { hostedBadgeAtom } from '@client/jotai/storefront/hosted-badge';
import { useShouldShowHostedBadge } from '@hooks/use-weddings-hosted-count-badge';
import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';

export const useStorefrontHostedBadgeAnalytics = (): void => {
	const { track } = useAnalyticsContext();
	const isEnabled = useShouldShowHostedBadge();
	const hostedBadge = useAtomValue(hostedBadgeAtom);
	const firedRef = useRef(false);

	useEffect(() => {
		if (!isEnabled || !hostedBadge || firedRef.current) {
			return;
		}

		firedRef.current = true;
		track({
			event: 'Milestone viewed',
			properties: {
				milestone: 'weddings hosted',
				band: hostedBadge.value,
			},
		});
	}, [hostedBadge, isEnabled, track]);
};
